var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.626C14.7467 19.626 19 15.3727 19 10.126C19 4.87938 14.7467 0.625974 9.5 0.625974C4.25328 0.625973 -6.1816e-07 4.87938 -1.07683e-06 10.126C-1.53552e-06 15.3727 4.25327 19.626 9.5 19.626ZM6.60516 9.48257C6.65146 9.43627 6.70225 9.39713 6.75513 9.36312L10.3205 5.79777C10.4936 5.62449 10.7206 5.53792 10.9476 5.53792C11.1746 5.53792 11.4015 5.62449 11.5747 5.79777C11.9212 6.14421 11.9212 6.70597 11.5747 7.05228L8.5025 10.125L11.5593 13.1817C11.9057 13.5284 11.9057 14.0899 11.5593 14.4363C11.2128 14.7827 10.6512 14.7825 10.3048 14.4364L6.7552 10.8871C6.70231 10.853 6.65152 10.814 6.60541 10.7676C6.42833 10.5905 6.3429 10.3573 6.34689 10.125C6.34271 9.89291 6.42795 9.65978 6.60516 9.48257Z",
    fill: "#9CE1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.a0761eea0770943cfb131e95c6420a5d.svg";
export { ForwardRef as ReactComponent };